import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Grid, TextField } from '@material-ui/core';
import { countries } from '../../utils/countries';

export const CountriesAutocomplete = ({ setSelectedCountries, selectedCountries }) => {
  const handleChangeCountries = (event, option) => {
    setSelectedCountries(option.map((c) => c.code));
  };
  return (
    <Grid item xs={12}>
      <Autocomplete
        multiple
        id="countries"
        options={countries}
        getOptionLabel={(option) => (option ? option.name : '')}
        value={selectedCountries ? selectedCountries.filter((c) => c !== '').map((c) => countries.find((country) => country.code === c)) : []}
        onChange={handleChangeCountries}
        renderInput={(params) => (
          <TextField
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...params}
            variant="standard"
            label="Countries"
          />
        )}
      />
    </Grid>
  );
};
